import { useCallback, useRef } from 'react';
import { useObserveTableElementRef } from '../../../virtualization/hooks/useObserveTableElementRef';
import { COLUMN } from '../../../virtualization/types/observerTypes';
import UIDragHandle from 'UIComponents/draggable/UIDragHandle';
import ContentComponentInner from '../ContentComponentInner';
import { ContentComponentWithDnDLegacyWrapper } from './ContentComponentWithDnDLegacyWrapper';
import { baseWrapperStyle, draggingWrapperStyle } from '../contentComponentStyles';
import { jsx as _jsx } from "react/jsx-runtime";
export function ContentComponentWithDnDLegacyInner({
  arrowsNode,
  children,
  columnIndex,
  columnName,
  columnNamespace,
  connectDragPreview,
  connectDragSource,
  connectDropTarget,
  draggedLeft,
  draggedRight,
  handleResize,
  isDragging,
  isLastColumn,
  onResizeEnd,
  originalWidth,
  reorderable,
  resizable
}) {
  const initialXRef = useRef(0);
  const handleMouseDown = useCallback(initiatingEvent => {
    initialXRef.current = initiatingEvent.clientX;

    // Prevent the initiating event from sorting or dragging
    initiatingEvent.preventDefault();
    const handleMouseMove = ({
      clientX
    }) => handleResize(originalWidth + (clientX - initialXRef.current));
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', event => {
      // Prevent the terminating event from sorting
      event.preventDefault();
      document.removeEventListener('mousemove', handleMouseMove);
      onResizeEnd();
    }, {
      once: true
    });
  }, [handleResize, onResizeEnd, originalWidth]);
  const handleClick = useCallback(event => {
    if (resizable) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, [resizable]);
  const handleObserveRef = useObserveTableElementRef();
  const dragHandle = reorderable ? connectDragSource(
  /*#__PURE__*/
  // This must be a div as well
  _jsx("div", {
    children: /*#__PURE__*/_jsx(UIDragHandle, {
      "data-test-id": `drag-header-${columnNamespace}-${columnName}`
    })
  })) : null;

  // This must be a div. It can't be a styled.div or any non-native element
  // because otherwise react-dnd complains
  const content = /*#__PURE__*/_jsx("div", {
    style: isDragging ? draggingWrapperStyle : baseWrapperStyle,
    ref: handleObserveRef,
    "data-observer-type": COLUMN,
    "data-observer-id": columnIndex,
    "data-test-id": `content-component-dnd-${columnName}`,
    children: /*#__PURE__*/_jsx(ContentComponentInner, {
      arrowsNode: arrowsNode,
      columnName: columnName,
      columnNamespace: columnNamespace,
      draggedLeft: draggedLeft,
      draggedRight: draggedRight,
      dragHandle: dragHandle,
      isDragging: isDragging,
      isLastColumn: isLastColumn,
      onClick: handleClick,
      onMouseDown: handleMouseDown,
      resizable: resizable,
      children: children
    })
  });
  if (reorderable) {
    return connectDropTarget(connectDragPreview(content));
  }
  return content;
}
export const ContentComponentWithDnDLegacy = ContentComponentWithDnDLegacyWrapper(ContentComponentWithDnDLegacyInner);